var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPoorRatingIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.1837 24.3673C18.9125 24.3673 24.3673 18.9125 24.3673 12.1837C24.3673 5.45481 18.9125 0 12.1837 0C5.45481 0 0 5.45481 0 12.1837C0 18.9125 5.45481 24.3673 12.1837 24.3673Z",
    fill: "#FFDD67"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.51242 12.0205C8.6339 12.0205 9.54303 11.1114 9.54303 9.98992C9.54303 8.86844 8.6339 7.9593 7.51242 7.9593C6.39095 7.9593 5.48181 8.86844 5.48181 9.98992C5.48181 11.1114 6.39095 12.0205 7.51242 12.0205Z",
    fill: "#664E27"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8528 12.0205C17.9742 12.0205 18.8834 11.1114 18.8834 9.98992C18.8834 8.86844 17.9742 7.9593 16.8528 7.9593C15.7313 7.9593 14.8221 8.86844 14.8221 9.98992C14.8221 11.1114 15.7313 12.0205 16.8528 12.0205Z",
    fill: "#664E27"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.52776 18.5186C10.8833 16.5692 13.4825 16.5692 15.838 18.5186C16.1222 18.7623 16.3659 18.3561 16.1629 17.9906C15.4318 16.6098 14.0104 15.3508 12.1829 15.3508C10.3553 15.3508 8.89327 16.6098 8.20286 17.9906C7.9998 18.3561 8.24348 18.7623 8.52776 18.5186Z",
    fill: "#664E27"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPoorRatingIcon);
export default __webpack_public_path__ + "static/media/poor-rating-icon.a3efbc8bbb3d38ee1f8c1a7c88e1f1d4.svg";
export { ForwardRef as ReactComponent };